import React from "react";

const STEPS = [
  { n: "01", title: "Define the objective", copy: "Tell Culmora what needs to be accomplished." },
  { n: "02", title: "Build the workflow", copy: "Culmora structures the work around the objective, available context and defined controls." },
  { n: "03", title: "Review before execution", copy: "Refine the result and approve what should move forward." },
  { n: "04", title: "Continue approved work", copy: "Save, collaborate, schedule or publish without restarting the workflow." },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="z-section-compact" data-testid="how-it-works">
      <div className="z-page">
        <div className="mb-6"><p className="z-eyebrow">Workflow</p><h2 className="mt-3 font-display text-[26px] md:text-[36px] leading-[1.1] max-w-[22ch]">How Culmora works.</h2></div>
        <ol className="border-y border-[hsl(var(--z-border))]" data-testid="how-it-works-steps">
          {STEPS.map((s, i) => (
            <li key={s.n} data-testid={`step-${s.n}`} className={`flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-6 py-5 md:py-6 ${i < STEPS.length - 1 ? "border-b border-[hsl(var(--z-border))]" : ""}`}>
              <div className="font-display text-[hsl(var(--z-teal))] text-[18px] md:text-[20px] leading-none w-12 shrink-0">{s.n}</div>
              <div className="flex-1 min-w-0"><h3 className="font-display text-[18px] md:text-[22px] leading-tight text-[hsl(var(--z-text))]">{s.title}</h3><p className="mt-1 text-[15.5px] md:text-[16.5px] leading-[1.55] text-[hsl(var(--z-text-muted))]">{s.copy}</p></div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
